(function () {
  "use strict";

  var root = document.getElementById("moc-booker");
  if (!root) return;

  var FORMSPREE = root.getAttribute("data-formspree") || "https://formspree.io/f/xqejdqrw";
  var ROSTER = (root.getAttribute("data-roster") || "").replace(/\/$/, "");
  var WEEKS_AHEAD = 20;
  var WEEKS_VISIBLE = 8;
  var CUTOFF_MINUTES = 60;
  var CLASS_CAPACITY = 12;
  var FIRST_PUBLIC_DATE = "2026-09-22";
  var CLOSED_DATES = {
    "2027-01-26": "No class this week",
  };
  var TZ = "Europe/Dublin";
  var STORAGE_KEY = "moc-balla-booking";

  var PASSES = {
    "drop-in": {
      id: "drop-in",
      label: "Pay as you go",
      amountEuro: 12,
      sessions: 1,
      blurb: "One class, no commitment.",
    },
    "pack-5": {
      id: "pack-5",
      label: "5 classes",
      amountEuro: 50,
      sessions: 5,
      blurb: "Pick any five Tuesdays.",
    },
    "pack-10": {
      id: "pack-10",
      label: "10 classes",
      amountEuro: 95,
      sessions: 10,
      blurb: "Pick any ten Tuesdays.",
    },
  };

  var SLOTS = [
    { id: "18:15", label: "6:15pm", hour: 18, minute: 15 },
    { id: "19:15", label: "7:15pm", hour: 19, minute: 15 },
  ];

  var state = {
    passType: "drop-in",
    timeSlot: "18:15",
    selectedDates: [],
    visibleCount: WEEKS_VISIBLE,
    name: "",
    email: "",
    phone: "",
    notes: "",
    website: "",
    waiver: false,
    error: "",
    submitting: false,
    payNow: false,
    pendingDate: "",
    occupancy: { capacity: CLASS_CAPACITY, slots: {} },
  };

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function dublinParts(at) {
    var parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: TZ,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).formatToParts(at || new Date());
    var get = function (type) {
      var part = parts.find(function (item) {
        return item.type === type;
      });
      return part ? part.value : "";
    };
    return {
      year: Number(get("year")),
      month: Number(get("month")),
      day: Number(get("day")),
      weekday: get("weekday"),
      hour: Number(get("hour")),
      minute: Number(get("minute")),
    };
  }

  function isoDateFromParts(year, month, day) {
    return year + "-" + pad(month) + "-" + pad(day);
  }

  function dublinToday(at) {
    var parts = dublinParts(at);
    return isoDateFromParts(parts.year, parts.month, parts.day);
  }

  function addDaysIso(iso, days) {
    var bits = iso.split("-").map(Number);
    var next = new Date(Date.UTC(bits[0], bits[1] - 1, bits[2] + days));
    return isoDateFromParts(next.getUTCFullYear(), next.getUTCMonth() + 1, next.getUTCDate());
  }

  function weekdayIndexUtc(iso) {
    var bits = iso.split("-").map(Number);
    return new Date(Date.UTC(bits[0], bits[1] - 1, bits[2])).getUTCDay();
  }

  function upcomingTuesdays(count, at) {
    var today = dublinToday(at);
    var weekday = weekdayIndexUtc(today);
    var daysUntilTuesday = (2 - weekday + 7) % 7;
    var cursor = addDaysIso(today, daysUntilTuesday);
    var dates = [];
    while (dates.length < count) {
      if (cursor >= FIRST_PUBLIC_DATE) dates.push(cursor);
      cursor = addDaysIso(cursor, 7);
    }
    return dates;
  }

  function displayDate(iso) {
    var bits = iso.split("-").map(Number);
    return new Intl.DateTimeFormat("en-IE", {
      weekday: "long",
      day: "numeric",
      month: "long",
    }).format(new Date(Date.UTC(bits[0], bits[1] - 1, bits[2])));
  }

  function slotById(slotId) {
    return SLOTS.find(function (slot) {
      return slot.id === slotId;
    });
  }

  function classStartMinutes(iso, slotId) {
    var slot = slotById(slotId);
    var bits = iso.split("-").map(Number);
    var utcNoon = Date.UTC(bits[0], bits[1] - 1, bits[2], 12, 0, 0);
    var dublinNoon = dublinParts(new Date(utcNoon));
    var offsetMinutes = dublinNoon.hour * 60 + dublinNoon.minute - 12 * 60;
    return Date.UTC(bits[0], bits[1] - 1, bits[2], slot.hour, slot.minute) - offsetMinutes * 60 * 1000;
  }

  function minutesUntilClass(iso, slotId, at) {
    return Math.round((classStartMinutes(iso, slotId, at) - (at || new Date()).getTime()) / 60000);
  }

  function slotStatus(iso, slotId, at) {
    if (CLOSED_DATES[iso]) {
      return { bookable: false, reason: CLOSED_DATES[iso], remaining: null };
    }
    var minutesLeft = minutesUntilClass(iso, slotId, at);
    if (minutesLeft < CUTOFF_MINUTES) {
      return {
        bookable: false,
        reason: minutesLeft < 0 ? "This class has started." : "Booking has closed for this class.",
        remaining: remainingFor(iso, slotId),
      };
    }
    var remaining = remainingFor(iso, slotId);
    if (remaining === 0) {
      return { bookable: false, reason: "Full", remaining: 0 };
    }
    return { bookable: true, reason: "", remaining: remaining };
  }

  function remainingFor(date, slotId) {
    var cap = CLASS_CAPACITY;
    if (state.occupancy && Number(state.occupancy.capacity)) {
      cap = Number(state.occupancy.capacity);
    }
    var row = state.occupancy && state.occupancy.slots && state.occupancy.slots[date];
    if (!row) return cap;
    var cell = row[slotId];
    if (!cell) return cap;
    if (typeof cell.remaining === "number") return Math.max(0, cell.remaining);
    return Math.max(0, cap - (Number(cell.taken) || 0));
  }

  function placesLeftLabel(remaining) {
    var left = remaining === null || remaining === undefined ? CLASS_CAPACITY : remaining;
    if (left <= 0) return "Full";
    if (left === 1) return "1 place left";
    return left + " places left";
  }

  function loadOccupancy() {
    if (!ROSTER) return Promise.resolve();
    var ctrl = typeof AbortController === "function" ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, 4000);
    return fetch(ROSTER + "/occupancy", {
      headers: { Accept: "application/json" },
      cache: "no-store",
      signal: ctrl ? ctrl.signal : undefined,
    })
      .then(function (response) {
        if (!response.ok) throw new Error("occupancy");
        return response.json();
      })
      .then(function (payload) {
        if (!payload || typeof payload !== "object" || payload.error) return;
        state.occupancy = {
          capacity: Number(payload.capacity) || CLASS_CAPACITY,
          slots: payload.slots || {},
        };
      })
      .catch(function () {
        /* Keep the 12-place labels if the list cannot be reached. */
      })
      .then(function () {
        clearTimeout(timer);
      });
  }

  function scheduleFor(timeSlot, at) {
    return upcomingTuesdays(WEEKS_AHEAD, at)
      .map(function (date) {
        var status = slotStatus(date, timeSlot, at);
        var nightOpen =
          !!CLOSED_DATES[date] ||
          SLOTS.some(function (slot) {
            return slotStatus(date, slot.id, at).bookable;
          });
        return {
          date: date,
          displayDate: displayDate(date),
          bookable: status.bookable,
          reason: status.reason,
          remaining: status.remaining,
          nightOpen: nightOpen,
        };
      })
      .filter(function (session) {
        return session.nightOpen;
      });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function makeReference() {
    var alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    var out = "";
    var bytes = new Uint8Array(4);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      bytes = [Date.now() & 255, Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256)];
    }
    for (var i = 0; i < 4; i++) out += alphabet[bytes[i] % alphabet.length];
    return "MOC-" + out;
  }

  function loadStoredBooking() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      if (!parsed) return null;
      if (parsed.payment === "now") return null;
      return parsed;
    } catch (err) {
      return null;
    }
  }

  function pass() {
    return PASSES[state.passType];
  }

  function currentSchedule() {
    return scheduleFor(state.timeSlot);
  }

  function bookableDates() {
    return currentSchedule()
      .filter(function (item) {
        return item.bookable;
      })
      .map(function (item) {
        return item.date;
      });
  }

  function pruneSelection() {
    var open = bookableDates();
    var next = state.selectedDates.filter(function (date) {
      return open.indexOf(date) !== -1;
    });
    if (next.length > pass().sessions) next = next.slice(0, pass().sessions);
    state.selectedDates = next;
  }

  function choosePass(id) {
    var extra = state.pendingDate;
    state.passType = id;
    state.error = "";
    state.pendingDate = "";
    if (pass().sessions > WEEKS_VISIBLE) {
      state.visibleCount = Math.min(WEEKS_AHEAD, Math.max(WEEKS_VISIBLE, pass().sessions + 2));
    }
    pruneSelection();
    if (id === "pack-10" && extra && state.selectedDates.indexOf(extra) === -1) {
      if (state.selectedDates.length < pass().sessions) {
        state.selectedDates = state.selectedDates.concat([extra]).sort();
      }
    }
    render();
  }

  function chooseTime(id) {
    state.timeSlot = id;
    state.error = "";
    pruneSelection();
    render();
  }

  function toggleDate(date, bookable) {
    if (!bookable) return;
    var selected = state.selectedDates.indexOf(date) !== -1;
    if (selected) {
      state.selectedDates = state.selectedDates.filter(function (item) {
        return item !== date;
      });
      state.error = "";
      state.pendingDate = "";
    } else if (pass().sessions === 1) {
      state.selectedDates = [date];
      state.error = "";
      state.pendingDate = "";
    } else if (state.selectedDates.length >= pass().sessions) {
      state.pendingDate = date;
      if (pass().id === "pack-5") {
        state.error =
          "You have 5 weeks selected. Tap a selected Tuesday to take it off, then tap this one. Or choose 10 classes to book more than 5.";
      } else {
        state.error =
          "You have " +
          pass().sessions +
          " weeks selected. Tap a selected Tuesday to take it off, then tap this one.";
      }
    } else {
      state.selectedDates = state.selectedDates.concat([date]).sort();
      state.error = "";
      state.pendingDate = "";
    }
    render();
  }

  function upgradeToTen() {
    choosePass("pack-10");
  }

  function selectNext(count) {
    var next = bookableDates().slice(0, count);
    if (next.length < count) {
      state.error =
        "Only " +
        next.length +
        (next.length === 1 ? " Tuesday has" : " Tuesdays have") +
        " places left at this time. Choose the other time, or pick weeks yourself.";
    } else {
      state.error = "";
    }
    state.selectedDates = next.slice(0, pass().sessions);
    state.visibleCount = Math.max(state.visibleCount, Math.min(currentSchedule().length, count + 2));
    state.pendingDate = "";
    render();
  }

  function readFields() {
    var name = root.querySelector("#moc-book-name");
    var email = root.querySelector("#moc-book-email");
    var phone = root.querySelector("#moc-book-phone");
    var notes = root.querySelector("#moc-book-notes");
    var website = root.querySelector("#moc-book-website");
    var waiver = root.querySelector("#moc-book-waiver");
    state.name = name ? name.value : state.name;
    state.email = email ? email.value : state.email;
    state.phone = phone ? phone.value : state.phone;
    state.notes = notes ? notes.value : state.notes;
    state.website = website ? website.value : state.website;
    state.waiver = waiver ? waiver.checked : state.waiver;
  }

  function onFieldInput() {
    readFields();
  }

  function confirmationHtml(booking) {
    var dates = (booking.dates || [])
      .map(function (date) {
        return "<li>" + escapeHtml(displayDate(date)) + "</li>";
      })
      .join("");
    return (
      '<div class="moc-booker-confirm" role="status">' +
      '<img class="moc-booker-logo" src="https://cdn.shopify.com/s/files/1/1257/4395/5990/files/brand_logo.jpg?v=1787754491" width="140" height="140" alt="Michelle O\'Connor Fitness">' +
      "<p class=\"booker-step\">You're in</p>" +
      '<p class="moc-booker-ref">' +
      escapeHtml(booking.reference) +
      "</p>" +
      '<p class="moc-class-body">I\'ll hold ' +
      (booking.dates.length === 1 ? "this place" : "these places") +
      " for " +
      escapeHtml(booking.name) +
      ". " +
      (booking.payment === "now"
        ? "Complete payment to hold this place. You will get a confirmation email after the card payment goes through."
        : "Pay <strong>€" +
          escapeHtml(String(booking.amountEuro)) +
          "</strong> in person at Balla Community Centre.") +
      "</p>" +
      '<p class="choice-meta" style="margin:0 0 12px">' +
      escapeHtml(booking.passLabel) +
      " · Tuesday " +
      escapeHtml(booking.timeLabel) +
      "</p>" +
      '<ul class="booker-dates">' +
      dates +
      "</ul>" +
      (booking.emailed
        ? '<p class="moc-class-body">A confirmation is on its way to ' +
          escapeHtml(booking.email || "your email") +
          ".</p>"
        : "") +
      '<p class="form-note" style="text-align:left">Need to change it? Email <a href="mailto:bookings@michelleoconnorfitness.com">bookings@michelleoconnorfitness.com</a> with your reference, or <a href="/pages/contact">get in touch</a>.</p>' +
      '<div class="hero-btns moc-booker-confirm__actions">' +
      '<button type="button" class="btn-primary" data-book-again>Book another class</button>' +
      "</div>" +
      "</div>"
    );
  }

  function bookAgain() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (err) {
      /* ignore */
    }
    state.selectedDates = [];
    state.submitting = false;
    state.payNow = false;
    state.error = "";
    state.pendingDate = "";
    render();
    if (root.scrollIntoView) {
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function bindConfirmation() {
    var again = root.querySelector("[data-book-again]");
    if (again) {
      again.addEventListener("click", bookAgain);
    }
  }

  function variantIdFor(passId) {
    return (root.getAttribute("data-variant-" + passId) || "").trim();
  }

  function canPayOnline() {
    return Boolean(variantIdFor(state.passType));
  }

  async function shopifyCart(path, options) {
    var response = await fetch(path, options || { headers: { Accept: "application/json" } });
    var payload = {};
    try {
      payload = await response.json();
    } catch (err) {
      payload = {};
    }
    if (!response.ok) {
      throw new Error(
        payload.description || payload.message || "Could not start checkout. You can still pay in person.",
      );
    }
    return payload;
  }

  async function addPassToCart(booking, chosen, slot, dateLabels) {
    var variantId = variantIdFor(chosen.id);
    if (!variantId) {
      throw new Error("Online payment isn't available just now. Reserve and pay in person.");
    }
    var properties = {
      Reference: booking.reference,
      Pass: chosen.label,
      Time: "Tuesday " + slot.label,
      Dates: dateLabels.join(", "),
      Name: booking.name,
      Phone: state.phone.trim(),
    };
    if (state.notes.trim()) properties.Notes = state.notes.trim();
    properties.Waiver = "Agreed";
    var item = {
      id: Number(variantId),
      quantity: 1,
      properties: properties,
    };
    async function putPassInCart() {
      await shopifyCart("/cart/clear.js", {
        method: "POST",
        headers: { Accept: "application/json" },
      });
      await shopifyCart("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: [item] }),
      });
    }
    await putPassInCart();
    var cart = await shopifyCart("/cart.js");
    if (Number(cart.item_count) !== 1) {
      await putPassInCart();
    }
  }

  function notifyRoster(details) {
    if (!ROSTER) return Promise.resolve();
    var body = JSON.stringify(details);
    function send(attempt) {
      return fetch(ROSTER + "/book", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: body,
      }).then(function (response) {
        if (response.status === 409) return response;
        if (!response.ok && attempt < 3) return send(attempt + 1);
        return response;
      }).catch(function () {
        if (attempt < 3) return send(attempt + 1);
      });
    }
    return send(1);
  }

  async function onSubmit(event) {
    event.preventDefault();
    readFields();
    state.error = "";
    var payNow = Boolean(event.submitter && event.submitter.getAttribute("data-pay") === "now");
    var chosen = pass();
    if (state.website) return;
    if (state.selectedDates.length !== chosen.sessions) {
      state.error =
        chosen.sessions === 1
          ? "Choose a Tuesday."
          : "Choose " + chosen.sessions + " Tuesdays (" + state.selectedDates.length + " selected).";
      render();
      return;
    }
    if (!state.name.trim() || !state.email.trim() || !state.phone.trim()) {
      state.error = "Name, email and phone are needed so I can hold your place.";
      render();
      return;
    }
    if (!state.waiver) {
      state.error = "Please tick the class waiver to book.";
      render();
      return;
    }

    var stillOpen = bookableDates();
    var blocked = state.selectedDates.filter(function (date) {
      return stillOpen.indexOf(date) === -1;
    });
    if (blocked.length) {
      state.error = "One of those Tuesdays has just filled or closed. Pick another week.";
      pruneSelection();
      render();
      return;
    }

    var slot = slotById(state.timeSlot);
    var fullPick = state.selectedDates.find(function (date) {
      return remainingFor(date, slot.id) === 0;
    });
    if (fullPick) {
      state.error =
        displayDate(fullPick) +
        " at " +
        slot.label +
        " is full. There are no places left. Pick another week or the other time.";
      pruneSelection();
      render();
      return;
    }
    var reference = makeReference();
    var dateLabels = state.selectedDates.map(displayDate);
    var message = [
      "Balla Tuesday booking " + reference,
      chosen.label + " · €" + chosen.amountEuro + " " + (payNow ? "pay now" : "pay in person"),
      "Time: Tuesday " + slot.label,
      "Dates:",
      dateLabels.map(function (label) {
        return "- " + label;
      }).join("\n"),
      state.notes.trim() ? "Note: " + state.notes.trim() : "",
      "Class waiver: agreed",
    ]
      .filter(Boolean)
      .join("\n");

    state.submitting = true;
    state.payNow = payNow;
    render();

    try {
      await loadOccupancy();
      var refreshedFull = state.selectedDates.find(function (date) {
        return remainingFor(date, slot.id) === 0;
      });
      if (refreshedFull) {
        throw new Error(
          displayDate(refreshedFull) +
            " at " +
            slot.label +
            " is full. There are no places left. Pick another week or the other time.",
        );
      }

      var emailed = false;
      var heldOnList = false;
      try {
        var rosterRes = await notifyRoster({
          reference: reference,
          name: state.name.trim(),
          email: state.email.trim(),
          phone: state.phone.trim(),
          notes: state.notes.trim(),
          passType: chosen.id,
          passLabel: chosen.label,
          timeSlot: slot.id,
          timeLabel: slot.label,
          dates: state.selectedDates.slice(),
          amountEuro: chosen.amountEuro,
          payment: payNow ? "pay now" : "pay in person",
          waiver: "agreed",
          website: state.website,
        });
        if (rosterRes && rosterRes.status === 409) {
          var fullPayload = await rosterRes.json().catch(function () {
            return {};
          });
          throw new Error(
            fullPayload.error ||
              "That class is full. There are no places left. Pick another week or the other time.",
          );
        }
        if (rosterRes && rosterRes.ok) {
          heldOnList = true;
          var rosterPayload = await rosterRes.json().catch(function () {
            return {};
          });
          emailed = Boolean(rosterPayload.emailed);
        }
      } catch (rosterErr) {
        if (rosterErr && /full/i.test(String(rosterErr.message || ""))) throw rosterErr;
        /* List unreachable — pay in person still goes by email; pay now waits for Shopify. */
      }

      if (!payNow) {
        var response = await fetch(FORMSPREE, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _subject: "Balla Tuesday booking " + reference + " — Michelle O'Connor Fitness",
            _replyto: state.email.trim(),
            type: "balla-tuesday-booking",
            name: state.name.trim(),
            email: state.email.trim(),
            phone: state.phone.trim(),
            pass: chosen.label,
            amount: "€" + chosen.amountEuro,
            payment: "pay in person",
            time: slot.label,
            dates: dateLabels.join(", "),
            dates_iso: state.selectedDates.join(", "),
            reference: reference,
            notes: state.notes.trim(),
            waiver: "agreed",
            message: message,
          }),
        });
        var data = {};
        try {
          data = await response.json();
        } catch (err) {
          data = {};
        }
        if (!response.ok && !heldOnList) {
          throw new Error(data.error || "Could not complete that booking. Please try again.");
        }
      }

      var booking = {
        reference: reference,
        name: state.name.trim(),
        email: state.email.trim(),
        passLabel: chosen.label,
        amountEuro: chosen.amountEuro,
        timeLabel: slot.label,
        dates: state.selectedDates.slice(),
        payment: payNow ? "now" : "person",
        emailed: emailed,
      };
      if (payNow) {
        await addPassToCart(booking, chosen, slot, dateLabels);
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch (err) {
          /* ignore */
        }
        window.location.assign("/checkout");
        return;
      }
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(booking));
      } catch (err) {
        /* ignore */
      }
      root.innerHTML = confirmationHtml(booking);
      bindConfirmation();
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    } catch (err) {
      state.submitting = false;
      state.error = err && err.message ? err.message : "Could not complete that booking. Please try again.";
      render();
    }
  }

  function render() {
    var stored = loadStoredBooking();
    if (stored && stored.reference && stored.dates && stored.dates.length) {
      root.innerHTML = confirmationHtml(stored);
      bindConfirmation();
      return;
    }

    pruneSelection();
    var chosen = pass();
    var schedule = currentSchedule();
    var openDates = bookableDates();
    var visible = schedule.slice(0, state.visibleCount);
    var canShowMore = state.visibleCount < schedule.length;

    var passButtons = Object.keys(PASSES)
      .map(function (id) {
        var item = PASSES[id];
        var pressed = state.passType === id;
        var extra = id === "drop-in" ? "" : " moc-class-price--block";
        return (
          '<button type="button" class="moc-class-price' +
          extra +
          '" aria-pressed="' +
          pressed +
          '" data-pass="' +
          item.id +
          '">' +
          '<p class="moc-class-price__label">' +
          escapeHtml(item.label) +
          "</p>" +
          '<p class="moc-class-price__amount">€' +
          item.amountEuro +
          "</p>" +
          '<p class="moc-class-body" style="margin:0">' +
          escapeHtml(item.blurb) +
          "</p>" +
          "</button>"
        );
      })
      .join("");

    var slotButtons = SLOTS.map(function (slot) {
      return (
        '<button type="button" class="choice" aria-pressed="' +
        (state.timeSlot === slot.id) +
        '" data-slot="' +
        slot.id +
        '">' +
        '<span class="choice-kicker">Tuesday</span>' +
        '<span class="choice-title">' +
        escapeHtml(slot.label) +
        "</span>" +
        '<span class="choice-meta">45 minutes · Balla</span>' +
        "</button>"
      );
    }).join("");

    var dateStep =
      chosen.sessions === 1 ? "3. Choose your Tuesday" : "3. Choose " + chosen.sessions + " Tuesdays";

    var toolbar = "";
    if (chosen.sessions > 1) {
      toolbar =
        '<p class="status-line" style="margin-bottom:12px">' +
        state.selectedDates.length +
        " of " +
        chosen.sessions +
        " selected. Tap weeks to add or remove them, or grab the next available run in one go. Full weeks are skipped.</p>" +
        '<div class="week-toolbar">' +
        (chosen.sessions >= 5
          ? '<button type="button" class="btn-outline week-toolbar__btn" data-select-next="5">Select the next 5 available Tuesdays</button>'
          : "") +
        (chosen.sessions >= 10
          ? '<button type="button" class="btn-outline week-toolbar__btn" data-select-next="10">Select the next 10 available Tuesdays</button>'
          : "") +
        "</div>";
    }

    var datesHtml;
    if (!openDates.length) {
      datesHtml =
        '<p class="booker-alert">This time is full for the weeks ahead. Try the other time, or get in touch.</p>';
    } else {
      datesHtml =
        '<div class="date-grid">' +
        visible
          .map(function (session) {
            var selected = state.selectedDates.indexOf(session.date) !== -1;
            var disabled = !session.bookable && !selected;
            var remaining = session.remaining;
            var meta;
            if (selected) {
              meta = "Selected · " + placesLeftLabel(remaining);
            } else if (session.bookable) {
              meta = placesLeftLabel(remaining);
            } else {
              meta = session.reason || "Full";
            }
            return (
              '<button type="button" class="choice' +
              (remaining === 0 ? " choice--full" : "") +
              '" aria-pressed="' +
              selected +
              '"' +
              (disabled ? " disabled" : "") +
              ' data-date="' +
              session.date +
              '" data-bookable="' +
              (session.bookable || selected) +
              '">' +
              '<span class="choice-title">' +
              escapeHtml(session.displayDate) +
              "</span>" +
              '<span class="choice-meta' +
              (remaining === 0 ? " choice-meta--full" : "") +
              '">' +
              escapeHtml(meta) +
              "</span>" +
              "</button>"
            );
          })
          .join("") +
        "</div>";
    }

    var showMore = canShowMore
      ? '<button type="button" class="btn-outline" style="width:100%;margin-bottom:28px" data-show-more>Show more Tuesdays</button>'
      : "";

    var selectedList = "";
    if (state.selectedDates.length > 1) {
      selectedList =
        '<p class="booker-step">Your Tuesdays</p><ul class="booker-dates">' +
        state.selectedDates
          .map(function (date) {
            return "<li>" + escapeHtml(displayDate(date)) + "</li>";
          })
          .join("") +
        "</ul>";
    }

    var dateCapNotice = "";
    if (state.error && state.pendingDate) {
      dateCapNotice =
        '<div class="booker-alert booker-alert--error" role="status" style="margin-bottom:20px">' +
        "<p style=\"margin:0\">" +
        escapeHtml(state.error) +
        "</p>" +
        (pass().id === "pack-5"
          ? '<button type="button" class="btn-outline" style="margin-top:14px" data-upgrade-ten>Choose 10 classes</button>'
          : "") +
        "</div>";
    }

    var error =
      state.error && !state.pendingDate
        ? '<p class="booker-alert booker-alert--error">' + escapeHtml(state.error) + "</p>"
        : "";

    root.innerHTML =
      '<form class="booker" novalidate>' +
      '<p class="moc-class-body">Small-group classes — 12 places in each. New bookings start Tuesday 22 September. Pay now on the website, or pay in person at Balla. I\'ll hold your place once you book.</p>' +
      '<p class="booker-step">1. Choose how you want to train</p>' +
      '<div class="moc-class-pricing moc-class-pricing--picks" style="margin-top:0;margin-bottom:28px">' +
      passButtons +
      "</div>" +
      '<p class="booker-step">2. Choose your time</p>' +
      '<div class="slot-grid">' +
      slotButtons +
      "</div>" +
      '<p class="booker-step">' +
      dateStep +
      "</p>" +
      toolbar +
      datesHtml +
      dateCapNotice +
      showMore +
      selectedList +
      '<p class="booker-step">4. Your details</p>' +
      '<div class="booker-fields">' +
      '<p class="moc-hp" aria-hidden="true"><label for="moc-book-website">Website</label>' +
      '<input id="moc-book-website" name="_gotcha" tabindex="-1" autocomplete="off" value="' +
      escapeHtml(state.website) +
      '"></p>' +
      '<div class="form-row"><div class="form-group">' +
      '<label class="form-label" for="moc-book-name">Name</label>' +
      '<input id="moc-book-name" class="form-input" autocomplete="name" required value="' +
      escapeHtml(state.name) +
      '">' +
      '</div><div class="form-group">' +
      '<label class="form-label" for="moc-book-phone">Phone</label>' +
      '<input id="moc-book-phone" class="form-input" autocomplete="tel" required value="' +
      escapeHtml(state.phone) +
      '">' +
      "</div></div>" +
      '<div class="form-group">' +
      '<label class="form-label" for="moc-book-email">Email</label>' +
      '<input id="moc-book-email" type="email" class="form-input" autocomplete="email" required value="' +
      escapeHtml(state.email) +
      '">' +
      "</div>" +
      '<div class="form-group">' +
      '<label class="form-label" for="moc-book-notes">Anything I should know? <span style="text-transform:none;letter-spacing:0">(optional)</span></label>' +
      '<textarea id="moc-book-notes" class="form-textarea" placeholder="Injuries, etc">' +
      escapeHtml(state.notes) +
      "</textarea>" +
      "</div></div>" +
      '<div class="booker-waiver">' +
      '<input id="moc-book-waiver" type="checkbox" required' +
      (state.waiver ? " checked" : "") +
      ">" +
      '<label for="moc-book-waiver">I have read and agree to the <a href="/pages/strength-class-waiver" target="_blank" rel="noopener">class waiver</a>.</label>' +
      "</div>" +
      error +
      '<div class="booker-pay' +
      (canPayOnline() ? "" : " booker-pay--solo") +
      '">' +
      '<div class="booker-pay-option">' +
      '<button type="submit" class="btn-primary" data-pay="person" ' +
      (state.submitting || !openDates.length ? "disabled" : "") +
      ">" +
      (state.submitting && !state.payNow ? "Holding your place…" : "Pay cash") +
      "</button>" +
      '<p class="form-note">You will receive a confirmation email and will pay on arrival.</p>' +
      "</div>" +
      (canPayOnline()
        ? '<div class="booker-pay-option">' +
          '<button type="submit" class="btn-outline" data-pay="now" ' +
          (state.submitting || !openDates.length ? "disabled" : "") +
          ">" +
          (state.submitting && state.payNow ? "Taking you to payment…" : "Pay online now") +
          "</button>" +
          '<p class="form-note">You will be redirected to checkout to pay online and will receive a confirmation email once completed.</p>' +
          "</div>"
        : "") +
      "</div>" +
      "</form>";

    var form = root.querySelector("form");
    if (form) form.addEventListener("submit", onSubmit);

    root.querySelectorAll("[data-pass]").forEach(function (button) {
      button.addEventListener("click", function () {
        readFields();
        choosePass(button.getAttribute("data-pass"));
      });
    });
    root.querySelectorAll("[data-slot]").forEach(function (button) {
      button.addEventListener("click", function () {
        readFields();
        chooseTime(button.getAttribute("data-slot"));
      });
    });
    root.querySelectorAll("[data-date]").forEach(function (button) {
      button.addEventListener("click", function () {
        readFields();
        toggleDate(button.getAttribute("data-date"), button.getAttribute("data-bookable") === "true");
      });
    });
    root.querySelectorAll("[data-select-next]").forEach(function (button) {
      button.addEventListener("click", function () {
        readFields();
        selectNext(Number(button.getAttribute("data-select-next")));
      });
    });
    var upgradeTen = root.querySelector("[data-upgrade-ten]");
    if (upgradeTen) {
      upgradeTen.addEventListener("click", function () {
        readFields();
        upgradeToTen();
      });
    }
    var more = root.querySelector("[data-show-more]");
    if (more) {
      more.addEventListener("click", function () {
        readFields();
        state.visibleCount = Math.min(currentSchedule().length, state.visibleCount + WEEKS_VISIBLE);
        render();
      });
    }
    ["moc-book-name", "moc-book-email", "moc-book-phone", "moc-book-notes", "moc-book-website"].forEach(function (id) {
      var field = root.querySelector("#" + id);
      if (field) field.addEventListener("input", onFieldInput);
    });
    var waiverBox = root.querySelector("#moc-book-waiver");
    if (waiverBox) {
      waiverBox.addEventListener("change", onFieldInput);
    }
  }

  loadOccupancy().then(function () {
    render();
  });
  render();
})();
